import React from "react";
import DecorativeSquares from "../ui/DecorativeSquares";

const OrderdetailShimmer = () => {
  return (
    <section className="relative min-h-screen max-w-7xl mx-auto px-4 py-6">
      <DecorativeSquares />

      {/* Header */}
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        <div className="w-8 h-8 rounded-full shimmer" />
        <div className="h-6 w-40 shimmer rounded-md mx-auto" />
      </div>

      {/* Customer Card */}
      <div className="px-0 md:px-4 mt-8">
        <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 shimmer rounded-md" />
              <div className="flex flex-col gap-2">
                <div className="h-4 w-40 shimmer rounded-md" />
                <div className="h-3 w-28 shimmer rounded-md" />
              </div>
            </div>

            <div className="flex gap-4">
              <div className="h-12 w-12 shimmer rounded-full" />
              <div className="h-12 w-12 shimmer rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="flex justify-center mt-4">
        <div className="h-6 w-24 rounded-full shimmer" />
      </div>

      {/* Order ID */}
      <div className="flex justify-center mt-3">
        <div className="h-4 w-40 shimmer rounded-md" />
      </div>

      {/* Meal Card */}
      <div className="md:px-4 mt-8">
        <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-4 md:p-6 shadow-sm">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 shimmer rounded-md" />

            <div className="flex flex-col gap-2">
              <div className="h-4 w-32 shimmer rounded-md" />
              <div className="h-4 w-20 shimmer rounded-md" />
            </div>
          </div>

          <div className="mt-4 flex gap-4">
            <div className="h-6 w-24 shimmer rounded-full" />
            <div className="h-4 w-28 shimmer rounded-md" />
          </div>

          <div className="border-b border-gray-200 mt-6 mb-4"></div>

          {/* Order detail header */}
          <div className="flex justify-between items-center">
            <div className="h-5 w-32 shimmer rounded-md" />
            <div className="w-6 h-6 shimmer rounded-md" />
          </div>

          {/* Table Skeleton */}
          <div className="mt-6 space-y-4">
            <div className="h-4 w-full shimmer rounded-md" />
            <div className="h-4 w-full shimmer rounded-md" />
            <div className="h-4 w-full shimmer rounded-md" />
            <div className="h-4 w-full shimmer rounded-md" />
          </div>
        </div>
      </div>

      {/* Bottom cards */}
      <div className="mb-8 space-y-6 max-w-7xl mt-4 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Delivery proof */}
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
            <div className="h-5 w-36 shimmer rounded-md mb-4" />
            <div className="w-full h-72 shimmer rounded-xl" />
          </div>

          {/* Delivery remark */}
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
            <div className="h-5 w-36 shimmer rounded-md mb-4" />
            <div className="h-4 w-full shimmer rounded-md mb-2" />
            <div className="h-4 w-3/4 shimmer rounded-md" />
          </div>
        </div>

        {/* Payment */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
          <div className="h-5 w-32 shimmer rounded-md mb-3" />
          <div className="h-4 w-40 shimmer rounded-md" />
        </div>

        {/* Order remark */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
          <div className="h-5 w-32 shimmer rounded-md mb-3" />
          <div className="h-4 w-full shimmer rounded-md" />
        </div>
      </div>
    </section>
  );
};

export default OrderdetailShimmer;
